import { GoogleCredentialResponse } from "@react-oauth/google";
import { adminApi } from "../../config";

type AuthToken = {
    token: string;
    message: string;
    success: string;
}

export const getRegister = async (data: any) => {
    console.log(data);
    try {
        // If FormData is passed, let axios handle multipart/form-data
        const res = await adminApi.post<AuthToken>("/mentor-register", data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log(res.data)
        return { success: res.data.success, message: res.data.message };
    } catch (err: any) {
        const message = err?.response?.data?.message || "An unexpected error occurred during registration.";
        return { success: false, message };
    }
}

export const getMentorLogin = async (data: any) => {
    try {
        const res = await adminApi.post("/mentor-login", data);
        return res.data;
    } catch (err: any) {
        try {
            const res2 = await adminApi.post("/admin-login", data);
            return res2.data;
        } catch (err2: any) {
            const message = err?.response?.data?.message || err2?.response?.data?.message || "An unexpected error occurred during login.";
            return { message, success: false };
        }
    }
}

export type GoogleLoginResponse = {
    token: string;
    role: string;
    message: string;
    mentorId?: string;
    isNewUser?: boolean;
    success?: boolean;
};

export type MentorPhoneLoginResponse = {
    success: boolean;
    token?: string;
    role?: string;
    mentorId?: string;
    user?: any;
    message?: string;
    isIncomplete?: boolean;
};

export const getGoogleLogin = async (response: GoogleCredentialResponse, role?: string, bankInfo?: any, additionalInfo?: any, certFile?: any): Promise<GoogleLoginResponse> => {
    try {
        const formData = new FormData();
        if (role) formData.append('role', role);
        if (bankInfo) formData.append('bankDetails', JSON.stringify(bankInfo));
        if (additionalInfo) formData.append('additionalInfo', JSON.stringify(additionalInfo));
        if (certFile) formData.append('certification', certFile);

        const res = await adminApi.post<GoogleLoginResponse>(
            "/google-login",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${response.credential}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return res.data;
    } catch (err: any) {
        return {
            success: false,
            message: err.response?.data?.message || "An unknown error occurred.",
            token: '',
            role: ''
        };
    }
}

// Mentor Phone Login
export async function mentorPhoneLoginApi(phone: string, role?: string): Promise<MentorPhoneLoginResponse> {
    try {
        const response = await adminApi.post<MentorPhoneLoginResponse>('/mentor-phone-login', { phone, role });

        if (response.status === 200) {
            return {
                success: true,
                token: response.data.token,
                role: response.data.role,
                user: response.data.user,
                message: response.data.message
            };
        } else {
            return {
                success: false,
                message: response.data.message || 'Phone login failed'
            };
        }
    } catch (error: any) {
        console.error("Mentor phone login error:", error);

        if (error.response) {
            return {
                success: false,
                message: error.response.data?.message || 'Phone login failed'
            };
        } else if (error.request) {
            return {
                success: false,
                message: 'No response received from server'
            };
        } else {
            return {
                success: false,
                message: `Error occurred: ${error.message}`
            };
        }
    }
}

export const checkPhoneApi = async (phone: string) => {
    try {
        const res = await adminApi.get<{ success: boolean; exists: boolean }>(`/check-phone/${phone}`);
        return res.data;
    } catch (err: any) {
        console.error("checkPhoneApi error:", err);
        return { success: false, exists: false };
    }
}